import React, { useState } from "react";
import RoleDashboardTab from "./dashRefactor/RoleDashboardTab";
import UserDashboardTab from "./dashRefactor/UserDashboardTab";

const UserDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState("users");

  const TabContent = () => {
    if (activeTab === "users") {
      return <UserDashboardTab />;
    } else if (activeTab === "roles") {
      return <RoleDashboardTab />;
    }
    return null;
  };

  return (
    <div className="min-h-screen py-6 w-full bg-[#F9F9F9] p-4">
      <div className="w-full mx-auto space-y-6">
        <h2 className="text-[20px] font-semibold">All users</h2>
        <div className="bg-white rounded-[10px] p-2 mt-5 h-[70px] flex items-center overflow-x-auto">
          <nav className="flex px-2 whitespace-nowrap min-w-max">
            <button
              onClick={() => setActiveTab("users")}
              className={`px-3 py-1 mr-4 font-medium text-[16px] transition-colors ${
                activeTab === "users"
                  ? "bg-primary/20 text-primary rounded-[8px]"
                  : "border-transparent text-pColor hover:text-hColor"
              }`}
            >
              Users
            </button>
            <button
              onClick={() => setActiveTab("roles")}
              className={`px-3 py-1 mr-4 font-medium text-[16px] transition-colors ${
                activeTab === "roles"
                  ? "bg-primary/20 text-primary rounded-[8px]"
                  : "border-transparent text-pColor hover:text-hColor"
              }`}
            >
              Roles
            </button>
          </nav>
        </div>
        {/* Tab Content */}
        <div className="mt-5">
          <TabContent />
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;
